//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";
import { Feedback } from "@/utils/notify-toaster.js";
const EMPTY_LINE = {
  retailer: {
    id: null,
    name: null
  },
  configuration: {
    email: null,
    weekdays: [],
    time: null,
    scheduled: false,
  },
  newObject: true
};

export default {
  name: "AutoOrder",
  components: {},
  data: function () {
    return {
      entries: [],
      retailerList: [],
      daysList: [
        { label: "Segunda", value: "monday" },
        { label: "Terça", value: "tuesday" },
        { label: "Quarta", value: "wednesday" },
        { label: "Quinta", value: "thursday" },
        { label: "Sexta", value: "friday" },
        { label: "Sábado", value: "saturday" },
        { label: "Domingo", value: "sunday" }
      ],
      emailStrings: [],
      time: null,
      proxyTime: null
    };
  },
  mounted: function () {
    this.fetchAutoOrderSchedulings();
  },
  methods: {
    fetchAutoOrderSchedulings: function () {
      // this.entries = [{ retailer: 1, configuration: { email: "bananas@bananas.com", weekdays: [1], time: 1 } }];
      BackendServices.getAutoOrderSchedulings().then(response => {
        let ignoredRetailers = [];
        for (const index in response.data) {
          ignoredRetailers.push(response.data[index].retailer.id);
        }
        BackendServices.getRetailers().then(response => {
          for (const index in response.data) {
            if (ignoredRetailers.includes(response.data[index].id)) {
              response.data.splice(index, 1);
              //TODO: Quando uma config é apagada, o retailer não volta a aparecer até novo pedido
            }
            this.retailerList = response.data.map(item => item);
          }
        }
        );
        for (const index in response.data) {
          this.entries.push(response.data[index]);
          this.emailStrings.push(response.data[index].configuration.email.join(','))
        }
      });
    },
    addLine: function () {
      let highestKey = null;
      for (let key in this.entries) {
        if (highestKey === null || key > highestKey) {
          highestKey = key;
        }
      }
      let tempEntries = JSON.parse(JSON.stringify(this.entries));

      if (tempEntries.length === 0) {
        tempEntries[0] = JSON.parse(JSON.stringify(EMPTY_LINE));
        this.entries = tempEntries;
        return;
      }
      tempEntries[parseInt(highestKey) + 1] = JSON.parse(JSON.stringify(EMPTY_LINE));
      this.entries = tempEntries;
    },
    removeEntry: function (index) {
      if (this.entries[index].newObject === undefined) {
        BackendServices.deleteAutoOrderScheduling(this.entries[index].configuration.id).then(response => {
          if (response.status === 204) {
            Feedback.success("Entrada removida com sucesso!");
          } else {
            Feedback.error("Erro em delete: " + response.statusText);
          }
        });
        this.entries.splice(index, 1);
      } else {
        this.entries.splice(index, 1);
      }
    },
    validateEmail(value) {
      var regex = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      var result = value.replace(/\s/g, "").split(/,|;/);
      for (var i = 0; i < result.length; i++) {
        if (!regex.test(result[i])) {
          return false;
        }
      }
      return true;
      // const emailFormat = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      // return emailFormat.test(value);
    },
    updateProxy(index) {
      this.proxyTime.value = this.entries[index].configuration.time
    },
    saveTime(index) {
      this.time.value = this.entries[index].configuration.time
    },
    updateEntry(index) {
      BackendServices.updateExistingAutoOrderScheduling(this.entries[index]).then(response => {
        if (response.status === 200) {
          Feedback.success("Entrada atualizada com sucesso!");
        } else {
          Feedback.error("Erro em update: " + response.statusText);
        }
      });

    },
    createEntry(index) {
      BackendServices.createAutoOrderScheduling(this.entries[index]).then(response => {
        if (response.status === 201) {
          this.entries[index].newObject = false;
          Feedback.success("Entrada criada com sucesso!");
        } else {
          Feedback.error("Erro em criação: " + response.statusText);
        }
      });
    },
    translateEmail(index) {
      if (this.emailStrings[index] === "") {
        this.entries[index].configuration.email = []
      } else {
        this.entries[index].configuration.email = this.emailStrings[index].split(',')
      }
    },
    exportAOSR() {
      Feedback.warning("Exportação iniciada.");
      BackendServices.downloadAutoOrderSupRec().then(
        (response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "AOSR.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      );
    },
    exportPacks() {
      Feedback.warning("Exportação iniciada.");
      BackendServices.downloadProductPacks().then(
        (response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "ProductPacks.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      );
    },
    exportPFA() {
      Feedback.warning("Exportação iniciada.");
      BackendServices.downloadPackFeatureAssoc().then(
        (response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "PFA.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      );
    },
  },
};
